import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const YO_URL = 'https://api.yo.xyz/api/v1/vault/stats'

const yoeth = 'Yield Optimizer ETH::YOETH'
const yobtc = 'Yield Optimizer BTC::YOBTC'
const yousd = 'Yield Optimizer USD::YOUSD'
const yoeur = 'Yield Optimizer EUR::yoEUR'

export const yoFetcher: YieldFetcher = {
  label: 'YO',
  fetch: async () => {
    const res = await fetch(YO_URL, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    }).then((r) => r.json())
    const datas = res?.data as any[]
    const yoETH = datas.find((a) => a.id === 'yoETH').yield?.['1d']
    const yoBTC = datas.find((a) => a.id === 'yoBTC').yield?.['1d']
    const yoUSD = datas.find((a) => a.id === 'yoUSD').yield?.['1d']
    const yoEUR = datas.find((a) => a.id === 'yoEUR').yield?.['1d']
    return {
      [yoeth]: apyToAprPercent(yoETH),
      [yobtc]: apyToAprPercent(yoBTC),
      [yousd]: apyToAprPercent(yoUSD),
      [yoeur]: apyToAprPercent(yoEUR),
    }
  },
}
